import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';


const DMED_LET = ({
  maxParrafos = 2,
  anchoTotal = 800,
  exercise, isRunning, velocity
}) => {
  const [texto, setTexto] = useState(exercise.content);
  const [posicionActual, setPosicionActual] = useState({ parrafo: 0, linea: 0 });
  const [lineaResaltada, setLineaResaltada] = useState(0);
  const altoLinea = 30;
  const alto = exercise.lineas * altoLinea
  //const alto = exercise.lineas * altoLinea * maxParrafos
  const margen = 30;
  const grosorLinea = 1;
  const anchoParrafo = (anchoTotal - (margen * (maxParrafos - 1))) / maxParrafos;
  const [lineas, setLineas] = useState([])
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  // Posiciones de las líneas decorativas para cada párrafo
  const lineasDecorativas = [0.25, 0.75];
  const numFilasTotal = exercise.lineas * maxParrafos;

  useEffect(() => {
    let intervalo = null
    if (isRunning && lineas.length > 0) {
      let numLineas = 0;
      for (let i = 0; i < lineas.length; i++) {
        numLineas += lineas[i].split(" ").length;
      }
      let velocidad = ((60 / velocity) * 1000);
      velocidad = velocidad * (numLineas / lineas.length);
      velocidad = velocidad - (1000 / 60);


      intervalo = setInterval(() => {

        setPosicionActual((prevPos) => {
          let nextParrafo = prevPos.parrafo;
          let nextLinea = prevPos.linea + 1;
  
          // Buscar la siguiente línea no vacía
          while (true) {
            if (nextLinea >= exercise.lineas) {
              nextParrafo = (nextParrafo + 1) % maxParrafos;
              nextLinea = 0;
            }
  
            if (lineas[nextParrafo * exercise.lineas + nextLinea].trim() !== '') {
              break;
            }
  
            nextLinea++;
  
            // Si hemos recorrido todos los párrafos y volvemos al inicio, salir del bucle
            if (nextParrafo === prevPos.parrafo && nextLinea === prevPos.linea) {
              return prevPos; // No hay cambios si todo está vacío
            }
          }
  
          return { parrafo: nextParrafo, linea: nextLinea };
        });
      }, velocidad);
    }

    return () => { if (intervalo) clearInterval(intervalo)};
  }, [maxParrafos, isRunning, lineas]);

  useEffect(()=> {
    console.log(lineaResaltada)
  }, [lineaResaltada])

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = '14px Arial';
      canvasRef.current = canvas;
    }
  }, []);

  const medirTexto = (texto: string): number => {
    if (canvasRef.current) {
      const context = canvasRef.current.getContext('2d');
      if (context) {
        return context.measureText(texto).width;
      }
    }
    return 0;
  };

  const dividirTexto = (texto: string, numLineasTotal: number): string[] => {
    const palabras = texto.split(' ');
    const lineas: string[] = [];
    let lineaActual = '';

    for (let i = 0; i < numLineasTotal; i++) {
      while (palabras.length > 0) {
        const palabraPrueba = lineaActual + (lineaActual ? ' ' : '') + palabras[0];
        if (medirTexto(palabraPrueba) <= anchoParrafo - 10) {
          lineaActual = palabraPrueba;
          palabras.shift();
        } else if (lineaActual === '') {
          // Si la palabra es más larga que el ancho, la cortamos
          let palabraCortada = '';
          for (let j = 0; j < palabras[0].length; j++) {
            if (medirTexto(palabraCortada + palabras[0][j]) <= anchoParrafo - 10) {
              palabraCortada += palabras[0][j];
            } else {
              break;
            }
          }
          lineaActual = palabraCortada;
          palabras[0] = palabras[0].substring(palabraCortada.length);
          break;
        } else {
          break;
        }
      }
      lineas.push(lineaActual);
      lineaActual = '';
    }

    // Si quedan palabras, las añadimos a la última línea
    if (palabras.length > 0 && lineas.length > 0) {
      lineas[lineas.length - 1] += ' ' + palabras.join(' ');
    }

    setLineas(lineas);
  };

  useEffect(()=> {
    dividirTexto(texto,28)
  }, [])

  const renderParrafo = (indiceParrafo: number) => {
    const lineasParrafo = lineas.slice(
      indiceParrafo * exercise.lineas,
      (indiceParrafo + 1) * exercise.lineas
    );
    const numEmpty = lineasParrafo.filter(ele => ele != "").length
    return (
      <>
      {numEmpty > 0 ? (
      <Box
        key={indiceParrafo}
        sx={{
          position: 'relative',
          width: anchoParrafo,
          height: exercise.lineas * altoLinea,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: posicionActual.parrafo === indiceParrafo ? posicionActual.linea * altoLinea : -altoLinea,
            left: 0,
            width: '100%',
            height: altoLinea,
            backgroundColor: 'lightblue',
            opacity: 0.5,
            //transition: 'top 0.3s ease-in-out',
          }}
        />
        {lineasParrafo.map((linea, index) => (
          <Typography
            key={index}
            variant="body2"
            sx={{
              position: 'absolute',
              top: index * altoLinea,
              left: 0,
              width: '100%',
              height: altoLinea,
              lineHeight: `${altoLinea}px`,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontSize: '14px',
              fontFamily: 'Arial',
              color: index === posicionActual.linea && posicionActual.parrafo === indiceParrafo ? "#000000" : "#999",
              clipPath: 'inset(0 0 40% 0)', // Oculta la mitad inferior de cada línea
            }}
          >
            {linea}
          </Typography>
        ))}
        {lineasDecorativas.map((posicion, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              top: 0,
              left: `${anchoParrafo * posicion}px`,
              width: `${grosorLinea}px`,
              height: '100%',
              backgroundColor: 'black',
            }}
          />
        ))}
      </Box>
      ):null}
      </>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%", // Cambia a 100vh para ocupar toda la altura de la ventana
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 1,
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        background: "#ffffff",
        
      }}
    >
    <Box
      sx={{
        display: 'flex',
        width: anchoTotal,
        height: alto,
        overflow: 'hidden',
        gap: `${margen}px`,
      }}
    >
      {Array.from({ length: maxParrafos }, (_, i) => renderParrafo(i))}
    </Box></Box>
  );
};

export default DMED_LET;

